var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "txtC padBM",
        staticStyle: { "border-bottom": "1px solid #ddd" }
      },
      [
        _c("img", {
          staticClass: "icoS",
          staticStyle: { "max-width": "115px" },
          attrs: {
            src: _vm.hybrisUrl + "/_ui/_noticeImg/logo/logo_amway_ci.png",
            alt: "Amway (로고)"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("p", {
      staticClass: "widM fntH4 bold marBML padTML",
      staticStyle: {
        color: "#2c2c2c",
        "line-height": "1.4",
        "letter-spacing": "normal"
      },
      domProps: { innerHTML: _vm._s(_vm._title) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a29bf42", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a29bf42","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyHeader.vue
// module id = null
// module chunks = 